import { createV3Queries } from "@query/utils/createV3Queries";
import { batchesApi } from "@api";

/**
 * Bulk-operation batches (`/v3/platform/batches`) — the v3 twin of the v1
 * bulk-importer batch collections.
 *
 * `listBatches` filters server-side on `type` (required inside `filter`) and
 * `status`, and pages on an opaque token. It offers no date filter and no
 * `sort`, so a screen that wants either has to page the whole collection with
 * `useQueryAll` and narrow client-side.
 */
export const queriesBatches = createV3Queries("batchesApi", batchesApi);
